// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__eGeh6","formControl":"addForm_formControl__BisGN","list":"addForm_list__2N6Pr","btnWrpper":"addForm_btnWrpper__vWLSS"};